import { BLACK, BLACK_100, BLACK_400, BLACK_500, BLACK_600, BLACK_700, BLACK_900, BLUE_500, BLUE_GREY_1000, BLUE_GREY_400, RED_600, LILAC_100, LILAC_400, LILAC_900, GREEN_600, YELLOW_600, WHITE } from '../../constants/colors';
export var inputDefaultProps = {
  label: '',
  hintText: '',
  state: 'none',
  useStateHintColor: true,
  isDisabled: false,
  numberOfInputs: 4
};
var lightConfig = Object.assign(Object.assign({}, inputDefaultProps), {
  config: {
    states: {
      none: {
        labelColor: BLACK_700,
        hintColor: BLACK_500,
        inputTextColor: BLACK_900,
        placeholderColor: BLACK_600,
        borderColor: LILAC_900,
        backgroundColor: LILAC_100
      },
      disabled: {
        inputTextColor: BLACK_400,
        placeholderColor: BLACK_700,
        borderColor: LILAC_400,
        backgroundColor: LILAC_100
      },
      hover: {
        backgroundColor: WHITE
      },
      focused: {
        borderColor: BLUE_500
      },
      success: {
        borderColor: GREEN_600,
        hintColor: GREEN_600
      },
      error: {
        borderColor: RED_600,
        hintColor: RED_600
      },
      warning: {
        borderColor: YELLOW_600,
        hintColor: YELLOW_600
      }
    }
  }
});
var darkConfig = Object.assign(Object.assign({}, inputDefaultProps), {
  config: {
    states: {
      none: {
        labelColor: BLACK_400,
        hintColor: BLACK_400,
        inputTextColor: BLACK_100,
        placeholderColor: BLACK_500,
        borderColor: BLACK_700,
        backgroundColor: BLACK_900
      },
      disabled: {
        inputTextColor: BLACK_700,
        placeholderColor: BLACK_700,
        borderColor: BLACK_600,
        backgroundColor: BLACK_900
      },
      hover: {
        borderColor: BLUE_500,
        backgroundColor: BLACK
      }
    }
  }
});
var whiteConfig = Object.assign(Object.assign({}, inputDefaultProps), {
  config: {
    states: {
      none: {
        labelColor: BLACK_700,
        hintColor: BLACK_500,
        inputTextColor: BLUE_GREY_1000,
        placeholderColor: BLACK_600,
        borderColor: BLUE_GREY_400,
        backgroundColor: WHITE
      },
      disabled: {
        inputTextColor: BLACK_400,
        placeholderColor: BLACK_700,
        borderColor: LILAC_400,
        backgroundColor: WHITE
      },
      hover: {
        backgroundColor: WHITE
      },
      focused: {
        borderColor: BLUE_500
      },
      success: {
        borderColor: GREEN_600,
        hintColor: GREEN_600
      },
      error: {
        borderColor: RED_600,
        hintColor: RED_600
      },
      warning: {
        borderColor: YELLOW_600,
        hintColor: YELLOW_600
      }
    }
  }
});
export default {
  light: lightConfig,
  dark: darkConfig,
  white: whiteConfig
};